<template>
    <div class="recharge-user">
        <div class="index-view-top">
            <div style="flex: 1">
                <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
            </div>
            <div style="flex: 1" class="title">{{ $t("head.recharge") }}</div>
            <div style="flex: 1" class="recharge-code" @click="withdrawalRecord">
                <p>{{ $t("head.top_up") }}</p>
            </div>
        </div>
        <van-cell-group inset style="margin:15px">
            <van-field v-model="account" :placeholder="tips1" />
        </van-cell-group>
        <div class="bizhong">
            {{ $t("vip.czpz") }}
        </div>
        <div style="margin:15px">
            <el-upload class="avatar-uploader" action="/api/upload/img" :show-file-list="false"
                :on-success="handleAvatarSuccess">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
        </div>
        <div class="nowLogin">
            <div @click="withdrawalRecord()">
                <p>{{ $t("vip.ljtj") }}</p>
            </div>
        </div>
        <div class="recharge-main">
            <div class="tips">
                <p style="color: #ffffff">{{ $t("recharge.remind") }}：</p>
                <p v-html="articleDetails"></p>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2';
import {
    recharge, article, img, submitRecharge
} from "@/utils/request";
export default {
    data() {
        return {
            address: "",
            articleDetails: "",//充值提示
            icon: 'USDT',
            tips1: this.$t("vip.zzhx"),//要转移的数量
            fileList: [],
            account: '',
            imageUrl: '',
            img: ''
        };
    },
    mounted() {
        this.getArticle()
    },
    methods: {
        handleAvatarSuccess(res, file) {
            console.log(file, res)
            this.imageUrl = URL.createObjectURL(file.raw);
            this.img = res.data.src
        },
        //充值提示
        getArticle() {
            article({ type: 'TIPS_DEPOSIT ' }).then((res) => {
                if (res.code == "200") {
                    this.articleDetails = res.data.content
                }
            });
        },
        withdrawalRecord() {
            if (this.account) {
                submitRecharge({
                    type: this.$route.query.icon,
                    price: this.$route.query.account,
                    txHash: this.account,
                    img: this.img,
                }).then((res) => {
                    if (res.code == "200") {
                        this.$toast.success(this.$t('phone.caozuo'))
                    } else {
                        this.$toast(res.msg)
                    }
                });
            } else {
                this.$toast(this.$t("vip.zzhx"));
            }

        },
        toBack() {
            this.$router.go("-1");
        },
    },
};
</script>
<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
</style>
<style>
.van-field__control {
    color: #ffffff !important;
}
</style>
<style lang="scss" scoped>
.bizhong {
    font-size: 15px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    padding: 15px;
}

.xuanze-icon {
    border: 1px solid #B6904D !important;
}

.van-cell {
    background: #110E31 !important;
    // background: #161414;
    //border-radius: 1.375rem;
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
    border: unset;
}

.van-cell-group {
    // background: #161414;
    background: #110E31 !important;
    border-radius: 4px;
}

.xuanze {
    display: flex;
    padding: 30px 15px;

    >div {
        width: 80px;
        height: 36px;
        border-radius: 5px;
        border: 1px solid #0c0b0b;
        margin-right: 10px;
        display: flex;
        align-items: center;
        justify-content: center;

        >p {
            font-size: 14px;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #B6904D;
        }
    }
}

.nowLogin {
    padding: 0 1.875rem;
    margin-bottom: 0.9375rem;
    margin-top: 0.25rem;

    >div {
        width: 100%;
        height: 2.6875rem;
        background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
        border-radius: 1.375rem;
        display: flex;
        align-items: center;
        justify-content: center;

        >p {
            font-size: 0.9375rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #0c0b0b;
        }
    }
}

.recharge-user {
    width: 100vw;
    height: 100vh;
    background: #0c0b0b;

    .tips {
        padding-top: .625rem;

        >p {
            display: inline-block;
            font-size: 0.75rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
            overflow: hidden;
            white-space: normal;
            word-break: break-all;
        }
    }

    .recharge-main {
        padding: 0.9375rem;

        .title {
            font-size: 0.875rem;
            font-family: PingFang SC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffc400;
        }

        .QR_code {
            width: 100%;
            border-radius: 0.625rem;
            border: 0.0625rem solid #272727;

            .address {
                font-size: 0.9375rem;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #ffffff;
                text-align: center;
                padding: 0.625rem 0;
            }

            .code {
                width: 180px;
                height: 180px;
                background: #ffffff;
                border-radius: 0.625rem;
                margin: 0 auto;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .nowLogin {
                padding: 0 1.875rem;
                margin-bottom: 0.9375rem;
                margin-top: 0.25rem;

                >div {
                    width: 100%;
                    height: 2.6875rem;
                    background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
                    border-radius: 1.375rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    >p {
                        font-size: 0.9375rem;
                        font-family: PingFang SC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #0c0b0b;
                    }
                }
            }
        }
    }

    .index-view-top {
        height: 3.625rem;
        padding: 0 0.9375rem;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
            font-size: 1.125rem;
            font-family: PingFang SC-Bold, PingFang SC;
            font-weight: bold;
            color: #ffffff;
            text-align: center;
        }

        .recharge-code {
            display: flex;

            >p {
                margin-left: auto;
                font-size: 0.9375rem;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #999999;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/user/shangchuan.vue